<template>
	<div class="zzAdminBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="delFlag" @qrsFn="delFn" rigTxt="确认" rigBg="#D33931" @callFn="delFlag = false" title="删除">
			<p style="text-align: center">是否确认删除</p>
		</dialogBox>
		<div class="zzAdminTabs">
			<div class="zzAdminTab">
				<div class="zzAdminItem active">歌曲</div>
			</div>
		</div>
		<div class="zzAdminConts">
			<div class="zzAdminCont" v-if="!perData.length">
				<el-empty description="暂无收藏"></el-empty>
			</div>
			<div class="zzAdminCont" v-if="perData.length">
				<div class="zzAdminG" v-for="(item, index) in perData" :key="index" @click="meiwBtn(item)">
					<div class="zzAdminItemImg">
						<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
					</div>
					<div class="zzAdminItemP">
						<div class="zzAdminItemTit">
							<p>{{ item.title }}</p>
						</div>
						<div class="zzAdminItemJj">
							<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(tabList.indexOf(i) + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
								{{ i }}
							</div>
						</div>
						<div class="zzAdminItemC" v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></div>
					</div>
					<div class="zzAdminItemDel" @click.stop="delBtn(item)">
						<img src="@/assets/img/shanc.svg" alt="" />
					</div>
				</div>
				<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
			</div>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
import fenye from '@/components/pubComponents/fenye';

export default {
	name: 'meiW',
	data() {
		return {
			delFlag: false,
			perData: [],
			total: 0,
			tabList: [],
			webpageResourceId: '',
			fullscreenLoading: false
		};
	},
	components: {
		dialogBox,
		fenye
	},
	methods: {
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydWebpageResource/list', {
					params: {
						type: 1,
						isCollect: 1,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			this.$http
				.get('api/app/yydWebpageResource/webpageResourceKeywords/list', {
					params: {
						type: 1
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.tabList = res.data.map((item) => {
							return item.resourceKeywordsName;
						});
						console.log(this.tabList, 8888);
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		btns(cont) {
			this.$emit('currCompBtn', cont);
		},
		delBtn(item) {
			this.webpageResourceId = item.webpageResourceId;
			this.delFlag = true;
		},
		delFn() {
			console.log(this.webpageResourceId, 777);
			if (this.webpageResourceId) {
				this.fullscreenLoading = true;
				this.$http.post(`api/app/yydCollect/cancel/1/${this.webpageResourceId}`).then((res) => {
					this.fullscreenLoading = true;
					if (res.code == 200) {
						this.delFlag = false;
						this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.perList();
					}
				});
			}
		},
		meiwBtn(item) {
			this.$router.push({
				path: 'scDec',
				query: {
					type: 1,
					txt: item.title,
					webpageResourceId: item.webpageResourceId,
					crumFlag: 1,
					tabFtxt: ['首页', '歌曲列表']
				}
			});
		}
	},
	activated() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zzAdminBox {
	flex: 1;
	margin-left: 10px;
	.zzAdminConts {
		background: #ffffff;
		border-radius: 0px 0px 6px 6px;
		padding: 0 15px;
		.zzAdminCont {
			margin-bottom: 100px;
			.zzAdminG {
				display: flex;
				padding: 15px 0;
				border-bottom: 1px solid #f8f8f8;
				align-items: center;
				cursor: pointer;
				&:last-of-type {
					border-bottom: none;
				}
				.zzAdminItemImg {
					width: 149px;
					height: 99px;
					margin-right: 10px;
				}
				.zzAdminItemP {
					width: 650px;
					.zzAdminItemJj {
						display: flex;
						align-items: center;
						.zzAdminItemJjI {
							padding: 0 10px;
							height: 20px;
							font-size: 12px;
							text-align: center;
							line-height: 20px;
							border-radius: 4px;
							margin-right: 10px;
							margin-bottom: 5px;
						}
						.zzAdminItemJjI0 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI1 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI2 {
							background: #f6fcf1;
							color: #5ec009;
						}
						.zzAdminItemJjI3 {
							background: #f1f7fe;
							color: #1675e5;
						}
						.zzAdminItemJjI5 {
							background: #fbf3ff;
							color: #bf2ff9;
						}
						.zzAdminItemJjI4 {
							background: #f2f7f3;
							color: #1d7b3a;
						}
					}
					.zzAdminItemFot {
						display: flex;
						align-items: center;
						.zzAdminItemk {
							display: flex;
							align-items: center;
							color: #8f9190;
							font-size: 12px;
							margin-right: 29px;
							img {
								width: 15px;
								height: 15px;
								margin-right: 4px;
							}
						}
					}
					.zzAdminItemC {
						color: #aeaeae;
						font-size: 14px;
						width: 647px;
						margin-bottom: 5px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.zzAdminItemTit {
						display: flex;
						align-items: center;
						margin-bottom: 6px;
						.zzAdminItemStat {
							width: 44px;
							height: 20px;
							background: #1d7b3a;
							font-size: 14px;
							color: #fff;
							margin-right: 10px;
							border-radius: 4px;
							text-align: center;
							line-height: 20px;
						}
						p {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
						.zzAdminItemYuy {
							display: flex;
							align-items: center;
							color: #93571c;
							font-size: 14px;
							margin-left: 25px;
							img {
								width: 14px;
								height: 14px;
								margin-right: 5px;
							}
						}
					}
				}
				.zzAdminItemDel {
					flex: 1;
					width: 20px;
					height: 22px;
					margin-right: 32px;
					cursor: pointer;
					text-align: right;
				}
			}
		}
	}
	.zzAdminTabs {
		height: 50px;
		background: #ffffff;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 26px;
		border-bottom: 1px solid #f3f4f7;
		.zzAdminTab {
			display: flex;
			font-size: 18px;
			color: #979797;
			align-items: center;
			.zzAdminItem {
				margin-right: 52px;
				cursor: pointer;
			}
			.active {
				color: #000;
				font-weight: bold;
			}
		}
		.zzAdminUp {
			display: flex;
			align-items: center;
			color: #1d7b3a;
			font-size: 14px;
			height: 100%;
			cursor: pointer;
			img {
				width: 16px;
				height: 16px;
				margin-right: 7px;
			}
		}
	}
}
</style>
